import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import './Auth.css';
import icon from '../../assets/icon.png';
import { signup, login } from '../../actions/auth';


const Auth = () => {
    const [isSignup, setIsSignup] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [referralCode, setReferralCode] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const refCode = params.get('ref');
        if (refCode) {
            setReferralCode(refCode);
            setIsSignup(true);
        }
    }, [location.search]);

    const handleSwitch = () => {
        setIsSignup(!isSignup);
        setName('');
        setEmail('');
        setPassword('');
        setUsername('');
        setReferralCode('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email && !password) {
            alert('Enter email and password');
            return;
        }
        if (isSignup) {
            if (!name) {
                alert("Enter a name to continue");
                return;
            }
            if (!username || username.trim() === '') {
                alert("Enter a username to continue");
                return;
            }
            dispatch(signup({ name, email, password, username, referralCode }, navigate));
        } else {
            dispatch(login({ email, password }, navigate));
        }
    };

    return (
        <section className='auth-section'>
            <div className='auth-container-2'>
                <div className='auth-header'>
                    <img src={icon} alt='HeyFren Logo' className='login-logo' />
                    <h1 className='auth-title'>{isSignup ? 'Create Account' : 'Welcome Back'}</h1>
                    <p className='auth-subtitle'>
                        {isSignup ? 'Join HeyFren to connect with your community' : 'Sign in to continue to HeyFren'}
                    </p>
                </div>
                
                <form onSubmit={handleSubmit} className='auth-form'>
                    {isSignup && (
                        <div className='input-group'>
                            <label htmlFor='name' className='input-label'>Display Name</label>
                            <div className='input-wrapper'>
                                <input
                                    type="text"
                                    id='name'
                                    name='name'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter your full name"
                                    className='auth-input'
                                />
                            </div>
                        </div>
                    )}
                    
                    {isSignup && (
                        <div className='input-group'>
                            <label htmlFor='username' className='input-label'>Username</label>
                            <div className='input-wrapper'>
                                <input
                                    type="text"
                                    id='username'
                                    name='username'
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="@username"
                                    className='auth-input'
                                />
                            </div>
                        </div>
                    )}
                    
                    <div className='input-group'>
                        <label htmlFor="email" className='input-label'>Email</label>
                        <div className='input-wrapper'>
                            <input
                                type="email"
                                name='email'
                                id='email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="your.email@example.com"
                                className='auth-input'
                            />
                        </div>
                    </div>
                    
                    <div className='input-group'>
                        <label htmlFor="password" className='input-label'>Password</label>
                        <div className='input-wrapper'>
                            <input
                                type="password"
                                name='password'
                                id='password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={isSignup ? "Create a strong password" : "Enter your password"}
                                className='auth-input'
                            />
                        </div>
                        {isSignup && (
                            <p className="input-hint">
                                Password must contain at least 8 characters, including at least 1 letter and 1 number.
                            </p>
                        )}
                    </div>

                    {isSignup && (
                        <div className='input-group'>
                            <label htmlFor='referralCode' className='input-label'>Referral Code <span className='optional'>(Optional)</span></label>
                            <div className='input-wrapper'>
                                <input
                                    type="text"
                                    id='referralCode'
                                    name='referralCode'
                                    value={referralCode}
                                    onChange={(e) => setReferralCode(e.target.value)}
                                    placeholder="Enter referral code"
                                    className='auth-input'
                                />
                            </div>
                        </div>
                    )}

                    {isSignup && (
                        <div className='checkbox-group'>
                            <label htmlFor='check' className="checkbox-label">
                                <input type="checkbox" id='check' className='checkbox-input' />
                                <span className="checkbox-text">
                                    Opt-in to receive occasional website updates, trending projects, and latest announcements.
                                </span>
                            </label>
                        </div>
                    )}

                    <button type='submit' className='auth-btn'>
                        <span>{isSignup ? 'Create Account' : 'Sign In'}</span>
                    </button>

                    {isSignup && (
                        <p className="terms-privacy-text">
                            By clicking "Create Account", you agree to our{' '}
                            <span className="inline-link">Terms of Service</span>,{' '}
                            <span className="inline-link">Privacy Policy</span> and{' '}
                            <span className="inline-link">Cookie Policy</span>.
                        </p>
                    )}
                </form>
                
                <div className='auth-footer'>
                    <p className="switch-prompt">
                        {isSignup ? "Already have an account?" : "Don't have an account?"}{' '}
                        <button type='button' className='handle-switch-btn' onClick={handleSwitch}>
                            {isSignup ? 'Sign In' : 'Sign Up'}
                        </button>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Auth;